import { combineReducers } from "redux";
import { loginReducer } from "./auth";
import { NewsReducer } from "./newsData";
import { FileReducer, getPublishedPapersReducer, projectInfoAdmin2Reducer, projectInfoReducer } from "./projectReducer";
import { SignUpDataReducer } from "./signUpData";


export const reducers = combineReducers({
  user: loginReducer,
  newsData:NewsReducer,
  signUpData:SignUpDataReducer,
  fileData:FileReducer,
  projectData:projectInfoReducer,
  projData:projectInfoAdmin2Reducer,
  publishedPapers:getPublishedPapersReducer
});
